/* ============================================================
   RS Landing JS — Reno Supplies
   Handles:
     1. Page-overview smooth scrolling with sticky-header offset
     2. Scrollspy (highlights the current section in the overview)
     3. Floating CTA show-after-scroll + hide-near-footer + close
   Vanilla JS, no dependencies. Safe to defer. Respects
   prefers-reduced-motion. All behaviour is namespaced and only
   runs when the relevant markup is present.
   ============================================================ */
(function () {
  'use strict';

  // Guard against being initialised twice if included by multiple sections.
  if (window.__rsLandingInit) return;
  window.__rsLandingInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Work out how tall a sticky/fixed header is so anchor jumps
     don't land under it. Falls back to the CSS variable value. */
  function getHeaderOffset() {
    var candidates = document.querySelectorAll(
      '.site-header, .header-wrapper, .site-header--sticky, [data-header-sticky]'
    );
    var offset = 0;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var pos = window.getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') {
        var rect = el.getBoundingClientRect();
        if (rect.height > offset && rect.top <= 1) offset = rect.height;
      }
    }
    return (offset || 72) + 16;
  }

  function smoothScrollTo(target) {
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  /* ---------- Overview navigation ---------- */
  function initOverview() {
    var overview = document.querySelector('[data-rs-overview]');
    if (!overview) return;

    var links = Array.prototype.slice.call(
      overview.querySelectorAll('[data-rs-scroll]')
    );
    if (!links.length) return;

    // Smooth scroll on click (keeps native hash for accessibility/history)
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = link.getAttribute('href');
        if (!id || id.charAt(0) !== '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        smoothScrollTo(target);
        // Move focus for screen-reader users without a second jump
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (history.replaceState) history.replaceState(null, '', id);
      });
    });

    // Scrollspy via IntersectionObserver
    var map = {};
    var targets = [];
    links.forEach(function (link) {
      var id = link.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var target = document.querySelector(id);
      if (target) { map[id] = link; targets.push(target); }
    });
    if (!targets.length || !('IntersectionObserver' in window)) return;

    var current = null;
    function setActive(id) {
      if (current === id) return;
      current = id;
      links.forEach(function (l) {
        var active = l.getAttribute('href') === id;
        if (active) { l.setAttribute('aria-current', 'true'); scrollChipIntoView(l); }
        else { l.removeAttribute('aria-current'); }
      });
    }

    function scrollChipIntoView(link) {
      var chips = link.closest('.rs31-overview__chips');
      if (!chips) return;
      var lr = link.getBoundingClientRect();
      var cr = chips.getBoundingClientRect();
      if (lr.left < cr.left || lr.right > cr.right) {
        chips.scrollTo({
          left: link.offsetLeft - 16,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
      }
    }

    var observer = new IntersectionObserver(function (entries) {
      // Pick the entry nearest the top that is intersecting
      var best = null;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (!best || entry.boundingClientRect.top < best.boundingClientRect.top) {
            best = entry;
          }
        }
      });
      if (best) setActive('#' + best.target.id);
    }, {
      rootMargin: '-' + getHeaderOffset() + 'px 0px -55% 0px',
      threshold: 0
    });

    targets.forEach(function (t) { observer.observe(t); });
  }

  /* ---------- Floating CTA ---------- */
  function initFloatingCTA() {
    var bars = document.querySelectorAll('[data-rs-floating]');
    Array.prototype.forEach.call(bars, function (bar) {
      var showAfter = parseInt(bar.getAttribute('data-show-after'), 10);
      if (isNaN(showAfter)) showAfter = 400;
      var hideNearFooter = bar.getAttribute('data-hide-footer') === 'true';
      var footer = document.querySelector('.site-footer, footer, [data-section-type="footer"]');
      var dismissed = false;

      var closeBtn = bar.querySelector('[data-rs-floating-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dismissed = true;
          bar.classList.remove('is-visible');
        });
      }

      function update() {
        if (dismissed) return;
        var scrolled = window.pageYOffset > showAfter;

        var nearFooter = false;
        if (hideNearFooter && footer) {
          var fRect = footer.getBoundingClientRect();
          // Hide once the footer enters the lower part of the viewport
          nearFooter = fRect.top < window.innerHeight - 40;
        }

        if (scrolled && !nearFooter) {
          bar.classList.add('is-visible');
          bar.classList.remove('is-hidden-footer');
        } else if (nearFooter) {
          bar.classList.add('is-hidden-footer');
          bar.classList.remove('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { update(); ticking = false; });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  function init() {
    initOverview();
    initFloatingCTA();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
